import { render, staticRenderFns } from "./ModalAssinantes.vue?vue&type=template&id=2492ca35&"
import script from "./ModalAssinantes.vue?vue&type=script&lang=js&"
export * from "./ModalAssinantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports